import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../resources/types'

const ToolCallOptionsSchema = z.object({
  timeout: z.number().optional().describe('Timeout in milliseconds'),
  app: z.string().min(1).describe('Handle of the app to use (required)'),
  appVersion: z
    .string()
    .optional()
    .default('prod')
    .describe('App version handle to use. Defaults to "prod".'),
  toolName: z.string().min(1).describe('Name of the app tool to invoke'),
})

export const ToolCallCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/app'),
    cmd: z.literal('tool.call'),
    options: ToolCallOptionsSchema,
  }),
  inputs: z
    .record(z.string(), z.unknown())
    .optional()
    .default({})
    .describe('Arguments to pass to the tool'),
})

export type ToolCallCommand = z.infer<typeof ToolCallCommandSchema>
